export function tableHeader(hidden = false) {
  const header = [
    { value: "year", align: "left" },
    { value: "age", align: "left" },
    { value: "Cover Amount", align: "left", hidden: hidden },
    { value: "monthly premium", align: "left" },
  ];
  const headerYearly = [
    { value: "year", align: "left" },
    { value: "age", align: "left" },
    { value: "Cover Amount", align: "left", hidden: hidden },
    { value: "yearly premium", align: "left" },
  ];
  return { header, headerYearly };
}
